import { Link } from 'react-router-dom';
import SEOHead from '@/components/SEOHead';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ArticleCard from '@/components/ArticleCard';
import { getHotArticles, getRecommendArticles, getLatestArticles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import { comments } from '@/mocks/comments';

const hotArticles = getHotArticles();
const recommendArticles = getRecommendArticles();
const latestArticles = getLatestArticles(4);
const topComments = comments.slice(0, 6);

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '猎奇吃瓜',
  url: 'http://odki7b.com/',
  description: '每日新鲜吃瓜八卦、冷门趣味爆料及无压力围观趣事',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://odki7b.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '猎奇吃瓜',
  url: 'http://odki7b.com/',
  logo: 'http://odki7b.com/logo.png',
  description: '中文娱乐八卦、猎奇趣闻聚合平台',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '猎奇吃瓜是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '猎奇吃瓜是一个中文娱乐八卦、猎奇趣闻聚合平台，主打新鲜吃瓜八卦、冷门趣味爆料及无压力围观趣事。每日更新猎奇向娱乐梗与新奇八卦合集。',
      },
    },
    {
      '@type': 'Question',
      name: '猎奇吃瓜的内容可信吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们严格筛选信息来源，标注信息出处，确保内容真实可靠。同时提醒用户理性吃瓜，对未经证实的爆料保持审慎态度。',
      },
    },
    {
      '@type': 'Question',
      name: '如何向猎奇吃瓜投稿爆料？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过邮件 hello@odki7b.com 向我们投稿，我们会保护爆料者隐私，对有价值的线索进行调查核实后发布。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="猎奇吃瓜 - 每日新鲜吃瓜八卦 | 冷门趣味爆料 | 无压力围观趣事"
        description="猎奇吃瓜首页汇聚新鲜吃瓜八卦、冷门趣味爆料及无压力围观趣事，每日更新猎奇向娱乐梗与新奇八卦合集，为围观心态提供解压谈资与社交分享素材，拒绝重复和垃圾信息。"
        keywords="猎奇吃瓜,新鲜吃瓜八卦,冷门趣味爆料,无压力围观趣事,新奇八卦合集,猎奇向娱乐梗,解压谈资,围观心态,每日吃瓜八卦,社交分享"
        canonical="http://odki7b.com/"
        ogImage="http://odki7b.com/og-image.jpg"
        schema={[websiteSchema, orgSchema, faqSchema]}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative min-h-[520px] md:min-h-[680px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20floating%20gossip%20speech%20bubbles%20and%20social%20media%20elements%2C%20coral%20and%20amber%20color%20palette%2C%20soft%20glow%20and%20warm%20atmosphere%2C%20modern%20digital%20art%20style%2C%20energetic%20and%20playful%20composition&width=1600&height=900&seq=hero-main&orientation=landscape"
              alt="猎奇吃瓜"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
          </div>

          <div className="relative w-full px-4 md:px-6 lg:px-10 pt-24 md:pt-28 pb-16 md:pb-20">
            <div className="max-w-3xl">
              <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
                每日新鲜吃瓜
                <br />
                <span className="text-accent-300">围观心态零压力</span>
              </h1>
              <p className="mt-4 md:mt-6 text-base md:text-lg text-white/85 max-w-xl leading-relaxed">
                汇聚全网最新八卦爆料、冷门趣味故事与解压谈资，每日更新，拒绝重复和垃圾信息，让你的围观时光更有价值。
              </p>
              <div className="mt-6 md:mt-8 flex flex-wrap gap-3">
                <Link
                  to="#trending"
                  className="inline-flex items-center gap-2 px-5 py-2.5 md:px-6 md:py-3 bg-accent-500 text-foreground-950 rounded-full text-sm md:text-base font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap"
                >
                  <i className="ri-fire-line" />
                  热门内容
                </Link>
                <Link
                  to="#categories"
                  className="inline-flex items-center gap-2 px-5 py-2.5 md:px-6 md:py-3 bg-white/15 text-white rounded-full text-sm md:text-base font-medium hover:bg-white/25 transition-colors whitespace-nowrap backdrop-blur-sm"
                >
                  <i className="ri-compass-3-line" />
                  探索分类
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Hot/Trending Articles */}
        <section id="trending" className="bg-background-100 py-10 md:py-16">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="flex items-center gap-3 mb-6 md:mb-8">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-white text-xl md:text-2xl" />
              </div>
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  热门吃瓜
                </h2>
                <p className="text-xs md:text-sm text-foreground-500">今日最火，全网围观</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {hotArticles.slice(0, 3).map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* Categories Grid */}
        <section id="categories" className="bg-background-50 py-10 md:py-16">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="mb-6 md:mb-8">
              <span className="text-xs md:text-sm font-medium text-primary-600 tracking-wider uppercase">
                探索发现
              </span>
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mt-1">
                新奇八卦
                <span className="italic text-primary-500 font-heading"> 合集</span>
              </h2>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group relative rounded-xl overflow-hidden aspect-[4/5] block"
                >
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                  <div className="absolute bottom-3 left-3 right-3">
                    <span className="text-white font-semibold text-sm md:text-base">
                      {cat.name}
                    </span>
                    <p className="text-white/70 text-xs mt-0.5 line-clamp-2 hidden sm:block">
                      {cat.description}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured / Curious Section */}
        <section className="bg-background-100 py-10 md:py-16">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="text-center mb-6 md:mb-8">
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
                冷门趣味<span className="text-secondary-600">爆料</span>
              </h2>
              <p className="text-sm text-foreground-500 mt-2">世界各地那些不可思议的真实故事</p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
              <ArticleCard article={recommendArticles[0]} variant="large" />
              <div className="flex flex-col gap-4 md:gap-5">
                {recommendArticles.slice(1, 3).map((article) => (
                  <ArticleCard key={article.id} article={article} variant="horizontal" />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="bg-background-50 py-10 md:py-16">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <span className="text-xs md:text-sm font-medium text-accent-600 tracking-wider uppercase">
                  新鲜出炉
                </span>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-1">
                  最新八卦
                </h2>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* Comments Section */}
        <section className="bg-background-100 py-10 md:py-16">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="mb-6 md:mb-8">
              <span className="inline-block px-3 py-1 rounded-lg bg-secondary-200 text-secondary-800 text-xs font-medium">
                网友神评
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
                神评论 · 解压谈资
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {topComments.map((comment) => (
                <div
                  key={comment.id}
                  className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={comment.avatar}
                      alt={comment.nickname}
                      className="w-10 h-10 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">
                        {comment.nickname}
                      </p>
                      <p className="text-xs text-foreground-400">
                        @{comment.account}
                      </p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    「{comment.content}」
                  </p>
                  <div className="flex items-center gap-1 mt-3 text-xs text-foreground-400">
                    <i className="ri-heart-line" />
                    <span>{comment.likes}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20bokeh%20lights%2C%20coral%20and%20amber%20tones%2C%20inviting%20and%20energetic%20atmosphere%2C%20modern%20digital%20art%2C%20subtle%20texture&width=1600&height=600&seq=cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/50" />
          </div>

          <div className="relative w-full px-4 md:px-6 lg:px-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white">
                  有独家猛料？
                </h2>
                <p className="mt-3 text-sm md:text-base text-white/80 max-w-md leading-relaxed">
                  匿名爆料通道已开启， securely 分享你身边的趣事、八卦和独家消息，让我们帮你传播！
                </p>
                <div className="mt-6">
                  <a
                    href="mailto:hello@odki7b.com"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-foreground-950 rounded-full text-sm md:text-base font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap"
                  >
                    立即爆料
                    <span className="w-6 h-6 rounded-full bg-foreground-950 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-accent-500 text-xs" />
                    </span>
                  </a>
                </div>
              </div>
              <div className="hidden lg:block text-right">
                <p className="text-white/70 text-sm leading-relaxed">
                  保护爆料者隐私，严格核实信息
                  <br />
                  有价值的内容将获重点推荐与曝光
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
